export default __webpack_public_path__ + "static/BG1-c5d059c24bbeafc76d69b2827de5d2ed.jpg";